import Checkbox, { CheckboxProps } from './checkbox';

export type { CheckboxProps };
export default Checkbox;
